"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreloadedImage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var Fade_1 = __importDefault(require("@material-ui/core/Fade"));
var core_1 = require("@material-ui/core");
var Placeholder_1 = require("../../atoms/Placeholder");
var styles_1 = __importDefault(require("./styles"));
/**
 * Preload wrapper for your images, will use background js preload in addition to browser sync and
 * decode attributes.
 *
 * * Includes a base64 placeholder and transitions.
 * * Images are set to 100% height as a default to help fit containers, this can be overridden as needed
 */
exports.PreloadedImage = react_1.default.memo(function (_a) {
    var src = _a.src, alt = _a.alt, props = __rest(_a, ["src", "alt"]);
    var classes = (0, styles_1.default)();
    var _b = (0, react_1.useState)(false), loaded = _b[0], setLoaded = _b[1];
    var _c = (0, react_1.useState)(false), visible = _c[0], setVisible = _c[1];
    var ref = (0, react_1.createRef)();
    var handleIntersection = function (entries) {
        var entry = entries[0];
        setVisible(entry.isIntersecting);
    };
    (0, react_1.useEffect)(function () {
        var intersectionOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 0,
        };
        var observer = new IntersectionObserver(handleIntersection, intersectionOptions);
        var refImg = ref.current;
        if (refImg)
            observer.observe(refImg);
        return function () {
            if (refImg)
                observer.unobserve(refImg);
        };
    }, [ref]);
    (0, react_1.useEffect)(function () {
        var img;
        var onImgLoad = function () {
            if ((img === null || img === void 0 ? void 0 : img.src) === src)
                setLoaded(true);
        };
        if (!loaded && visible) {
            img = new Image();
            img.addEventListener('load', onImgLoad);
            img.src = src;
        }
        return function () { return img === null || img === void 0 ? void 0 : img.removeEventListener('load', onImgLoad); };
    }, [src, visible, loaded]);
    return (
    // NOTE: Box cannot use a ref so we need to use an inner div
    (0, jsx_runtime_1.jsx)(core_1.Box, __assign({}, props, { className: classes.root }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ ref: ref, className: classes.trigger }, { children: loaded ? ((0, jsx_runtime_1.jsx)(Fade_1.default, __assign({ in: loaded }, { children: (0, jsx_runtime_1.jsx)("img", { decoding: "async", alt: alt, src: src, className: classes.image }) }))) : ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.placeholder }, { children: (0, jsx_runtime_1.jsx)(Placeholder_1.Placeholder, { "data-imgsrc": src }) }))) })) })));
});
